// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AadharDetailsActionType from './aadhar-details.types';
import {
	updateAadharSuccess,
	updateAadharFailure,
	updateAadharResponseChanged,
	sendAaharOTPSuccess,
	sendAaharOTPFailure,
	sendAaharOTPResponseChanged,
} from './aadhar-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { aadharUpdateDetails, memberAaharOtp } from './aadhar-details.service';

/** ***************** UPDATE AADHAR START *********************** */
export function* updateAadharIdDetails({ payload }: any) {
	try {
		const key = 'updateAadharID';
		const {
			companyID,
			databaseName,
			memberID,
			memberAadharFrontImg,
			memberAadharBackImg,
			docType,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberAadharFrontImg: memberAadharFrontImg,
			MemberAadharBackImg: memberAadharBackImg,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};

		const aadharData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(aadharUpdateDetails, aadharData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAadharFailure(responseData.data));
		} else {
			yield put(updateAadharSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAadharFailure(error));
	}
}

export function* updateAadharDetailsResponseClear() {
	yield put(updateAadharResponseChanged());
}

export function* onAadharDetailsUpdateStart() {
	yield takeLatest(AadharDetailsActionType.UPDATE_AADHAR_START, updateAadharIdDetails);
}

export function* onAadharDetailsUpdateResponseRest() {
	yield takeLatest(
		AadharDetailsActionType.UPDATE_AADHAR_RESPONSE_REST_START,
		updateAadharDetailsResponseClear,
	);
}
/** ***************** UPDATE AADHAR END *********************** */

/** ***************** AADHAR OTP START *********************** */
export function* CallMemberAdharOtp({ payload }: any) {
	try {
		const key = 'verifyAadharOtp';
		const {
			memberID,
			databaseName,
			companyID,
			memberAadharNumber,
			memberPhoneNumber,
			sendOTP,
		} = payload;

		const jsonData = {
			MemberID: memberID,
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			AadharNumber: memberAadharNumber,
			MemberPhoneNumber: memberPhoneNumber,
			Secratekey: key,
			SendOTP: sendOTP,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberAaharOtp, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(sendAaharOTPFailure(responseData.data));
		} else {
			yield put(sendAaharOTPSuccess(responseData.data));
		}
	} catch (error) {
		yield put(sendAaharOTPFailure(error));
	}
}

export function* VerifyMemberAadharClear() {
	yield put(sendAaharOTPResponseChanged());
}

export function* onVerifyMemberAadharStart() {
	yield takeLatest(AadharDetailsActionType.SEND_AADHAR_OTP_START, CallMemberAdharOtp);
}

export function* onVerifyMemberAadharResponseRest() {
	yield takeLatest(
		AadharDetailsActionType.SEND_AADHAR_OTP_RESPONSE_RESET,
		VerifyMemberAadharClear,
	);
}
/** ***************** AADHAR OTP END *********************** */

export function* aadharDetailsSaga() {
	yield all([
		call(onAadharDetailsUpdateStart),
		call(onAadharDetailsUpdateResponseRest),
		call(onVerifyMemberAadharStart),
		call(onVerifyMemberAadharResponseRest),
	]);
}
